module.exports = __webpack_public_path__ + "img/offers-setup.52b1d987.jpg";